import React from 'react';
import Slider from '../Components/Slider';
import { Modal, Box } from '@mui/material';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';
import { darkModeBackgroudInputs } from '../../../../utils/constants';
import { TicketImageInterface } from '../../../../models/TicketModule/TicketImage';

interface PhotoModalCompProps {
    open: boolean;
    selectedIndex: number;
    photos: TicketImageInterface[];
    handleClose: () => void;
}

export const PhotoModalComp: React.FC<PhotoModalCompProps> = ({ photos, open, selectedIndex, handleClose }) => {
    const { darkMode } = useDarkModeStore();
    return (
        <Modal
            open={open}
            disableAutoFocus
            disableEnforceFocus
            sx={{ zIndex: 2000 }}
            onClose={() => handleClose()}
        >
            <Box
                sx={{
                    p: 2,
                    top: '50%',
                    left: '50%',
                    width: '50%',
                    boxShadow: 24,
                    outline: 'none',
                    maxHeight: '80%',
                    overflow: 'hidden',
                    position: 'absolute',
                    borderRadius: '10px',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: darkMode ? darkModeBackgroudInputs : '#F3F3F7',
                }}
            >
                <Slider photos={photos} initialIndex={selectedIndex} />
            </Box>
        </Modal>
    );
}
export default PhotoModalComp